import { render, staticRenderFns } from "./BaseFooter.vue?vue&type=template&id=2adf712a"
var script = {}
import style0 from "./BaseFooter.vue?vue&type=style&index=0&id=2adf712a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports